import { render, staticRenderFns } from "./NoOperateOrderRemarkList.vue?vue&type=template&id=2fa58a26&scoped=true"
import script from "./NoOperateOrderRemarkList.vue?vue&type=script&lang=js"
export * from "./NoOperateOrderRemarkList.vue?vue&type=script&lang=js"
import style0 from "./NoOperateOrderRemarkList.vue?vue&type=style&index=0&id=2fa58a26&prod&scoped=true&lang=css"
import style1 from "./NoOperateOrderRemarkList.vue?vue&type=style&index=1&id=2fa58a26&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa58a26",
  null
  
)

export default component.exports